import React from 'react'
import { Feature } from '../../Models/Feature'

interface Props {
  feature: Feature;
}

const FeatureProduct = ({ feature }: Props) => {
  return (
    <div className='product-feature-item'>
      {React.isValidElement(feature.icon)
        ? React.cloneElement(feature.icon as React.ReactElement<{ size?: number }>, { size: 20 })
        : feature.icon}
      <span>{feature.name}</span>
    </div>
  )
}

export default FeatureProduct